import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetInventoryStockListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetInventoryStockListingAttempt', handleGetInventoryListing, api);
}

function* handleGetInventoryListing(api: GoldGateway) {
    const reduxState = store.getState();

    const authToken = reduxState.auth.userDetails.authToken;

    const {
        index,
    } = reduxState.gold.goldInventory.inventoryListing;

    const {
        branchCode,
        metalType,
    } = reduxState.gold.params.inventoryFilterParams || {};

    if (!index && index !== 0) {
        yield put(
            combinedActions.goldGetInventoryStockListingFailure(
                ErrorMessages.GenericRequiredFieldNotFilledIn
            )
        );
        return;
    }

    const response = yield* call(
        [api, api.getInventoryListing],
        {
            authToken,
            index,
            ...(metalType && { metalType: Number(metalType) }),
            ...(branchCode && { branchCode }),
        }
    );

    if (response.status === GatewayResponseStatus.Error) {
        yield put(
            combinedActions.goldGetInventoryStockListingFailure(
                response.message || ErrorMessages.GenericError
            )
        );
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(
            combinedActions.goldGetInventoryStockListingSuccess(
                response.data
            )
        );
    }
}
